// Mock data for The Lighthouse Coaching Institute

export const courses = [
  {
    id: 1,
    title: "Primary School",
    grades: "Classes 1-5",
    subjects: ["Mathematics", "Science", "English", "Social Studies", "Hindi", "All Subjects"],
    description: "Building strong fundamentals in all subjects with focus on conceptual clarity and interactive learning.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-purple"
  },
  {
    id: 2,
    title: "Middle School",
    grades: "Classes 6-8",
    subjects: ["Mathematics", "Science", "English", "Social Studies", "Hindi", "All Subjects"],
    description: "Comprehensive coaching in all subjects preparing students for secondary education with strong foundations.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-blue"
  },
  {
    id: 3,
    title: "Secondary School",
    grades: "Classes 9-10",
    subjects: ["Mathematics", "Science (Physics, Chemistry, Biology)"],
    description: "Intensive board exam preparation in Maths and Science with regular mock tests and personalized attention.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-orange"
  },
  {
    id: 4,
    title: "Science Stream - PCM",
    grades: "Classes 11-12",
    subjects: ["Physics", "Chemistry", "Mathematics"],
    description: "Advanced coaching for PCM students preparing for boards, JEE, and other engineering entrance exams.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-green"
  },
  {
    id: 5,
    title: "Science Stream - PCB",
    grades: "Classes 11-12",
    subjects: ["Physics", "Chemistry", "Biology"],
    description: "Comprehensive coaching for PCB students targeting NEET, boards, and medical entrance examinations.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-pink"
  },
  {
    id: 6,
    title: "Commerce Stream",
    grades: "Classes 11-12",
    subjects: ["Accountancy", "Economics", "Business Studies"],
    description: "Complete commerce education with practical applications, case studies, and board exam strategies.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-grey"
  },
  {
    id: 7,
    title: "Humanities Stream",
    grades: "Classes 11-12",
    subjects: ["History", "Political Science", "Economics", "Geography"],
    description: "Expert guidance for humanities students with focus on analytical thinking and writing skills.",
    duration: "Flexible Timing",
    mode: ["Offline", "Online", "Home Tuition"],
    color: "accent-purple"
  }
];

export const faculty = [
  {
    id: 1,
    name: "Priyanshu Singh",
    designation: "Founder & Director (IIT-ian)",
    specialization: "Mathematics & Science Wizard",
    experience: "5+ years of teaching experience",
    education: "Graduation from IIT Patna, Certified from Harvard University",
    image: "/images/priyanshu.jpg"
  },
 
  {
    id: 2,
    name: "Anjum",
    designation: "Commerce Expert",
    specialization: "Accountancy Expert",
    experience: "8+ years of teaching experience",
    education: "M.Com & B.Com",
    image: "/images/anjum.jpg"
  },
   {
    id: 3,
    name: "Aastha Jha",
    designation: "Expert Faculty",
    specialization: "Nurturing young minds",
    experience: "4+ years of teaching experience",
    education: "B.Tech CSE",
    image: "https://"
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Ananya Patel",
    grade: "Class 12 - Science",
    score: "95.4%",
    year: "2024",
    message: "The personalized attention and doubt-solving sessions at Lighthouse helped me score 95.4% in boards. The crash course for Math was especially helpful!",
    avatar: "AP"
  },
  {
    id: 2,
    name: "Rohan Mehta",
    grade: "Class 10 - CBSE",
    score: "96.2%",
    year: "2024",
    message: "Best coaching institute in Noida! Teachers are very supportive and the study material is excellent. Highly recommend for board exam preparation.",
    avatar: "RM"
  },
  {
    id: 3,
    name: "Shreya Singh",
    grade: "Class 11 - Commerce",
    score: "Topper",
    year: "2023",
    message: "The faculty here made Accounts and Economics so easy to understand. One-to-one mentoring sessions really helped build my concepts.",
    avatar: "SS"
  },
];

export const gallery = [
  {
    id: 1,
    title: "Meet Our Recent Toppers",
    images: [
      "/images/pratik.jpg",
       "/images/class10resultposter.jpg",
       "/images/resultposter.jpg",
       "/images/sanskriti.jpg",
       "/images/arsh.jpg",
      "/images/shreyansh.jpg",
       "/images/aarohi.jpg"
    ],
    category: "Results"
  },
  {
    id: 2,
    title: "Kids Corner",
    images: [
      "/images/ajay.jpg",
       "/images/kautilya.jpg",
       "/images/avni.jpg"
      ],
    category: "Results"
  },
  {
    id: 3,
    title: "Student Trips & Outings",
    images: [
    "https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/8rhhdv8p_Screenshot%20%2843%29.png"
      ],
    category: "Activities"
  },
  {
    id: 4,
    title: "Weekly & Monthly Tests",
    images: [
    "/images/mocktest3.jpg"
      ],
    category: "Tests & Assessment"
  },
  {
    id: 5,
    title: "Study Environment",
    images: [
    "/images/classroomkids.jpg"
      ],
    category: "Classroom"
  },
  {
    id: 6,
    title: "Regular Activities",
    images: [
    "/images/merrychristmas.jpg"
      ],
    category : "Activities"
  },
  {
    id: 7,
    title: "Reading Space",
    images: [
    "/images/readingarea.jpg"
      ],
    category: ""
  },
  {
    id: 8,
    title: "Interactive Learning",
    images: [
    "/images/classroomseniors.jpg"
      ],
  },
  {
    id: 9,
    title: "One-on-One Mentoring",
    images: [
    "/images/tanishiteaching.jpg"
      ],
    category: "Teaching"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "10 Effective Study Techniques for Board Exams",
    excerpt: "Discover proven strategies to maximize your board exam preparation and achieve top scores.",
    author: "Dr. Rajesh Kumar",
    date: "2024-12-01",
    category: "Study Tips",
    readTime: "5 min"
  },
  {
    id: 2,
    title: "How to Choose Between Science and Commerce After Class 10",
    excerpt: "A comprehensive guide to help students make informed decisions about their academic stream.",
    author: "Priya Sharma",
    date: "2024-11-28",
    category: "Career Guidance",
    readTime: "7 min"
  },
  {
    id: 3,
    title: "Mathematics Made Easy: Tips from IIT Graduate",
    excerpt: "Learn advanced problem-solving techniques and shortcuts for mastering mathematics.",
    author: "Dr. Rajesh Kumar",
    date: "2024-11-25",
    category: "Mathematics",
    readTime: "6 min"
  },
  {
    id: 4,
    title: "The Importance of Conceptual Clarity in Science",
    excerpt: "Why understanding concepts is more important than rote learning in Physics, Chemistry, and Biology.",
    author: "Amit Verma",
    date: "2024-11-20",
    category: "Science",
    readTime: "5 min"
  }
];

export const schedules = [
  {
    id: 1,
    class: "Classes 9-10",
    timing: "Morning Batch: 7:00 AM - 9:00 AM",
    days: "Mon, Wed, Fri",
    mode: "Offline"
  },
  {
    id: 2,
    class: "Classes 9-10",
    timing: "Evening Batch: 5:00 PM - 7:00 PM",
    days: "Tue, Thu, Sat",
    mode: "Offline"
  },
  {
    id: 3,
    class: "Classes 11-12 (Science)",
    timing: "Morning Batch: 6:00 AM - 8:30 AM",
    days: "Mon to Sat",
    mode: "Offline"
  },
  {
    id: 4,
    class: "Classes 11-12 (Commerce)",
    timing: "Evening Batch: 6:00 PM - 8:00 PM",
    days: "Mon, Wed, Fri",
    mode: "Offline"
  },
  {
    id: 5,
    class: "Online Classes (All Grades)",
    timing: "Flexible Timings",
    days: "Mon to Sat",
    mode: "Online"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What boards do you provide coaching for?",
    answer: "We provide coaching for CBSE, ICSE, and State Board students from Classes 1 to 12."
  },
  {
    id: 2,
    question: "Do you offer online classes?",
    answer: "Yes, we offer both offline classroom coaching and online interactive classes. We also provide home tuition services across Delhi NCR."
  },
  {
    id: 3,
    question: "What is the batch size?",
    answer: "We maintain small batch sizes (10-15 students) to ensure personalized attention and effective doubt-solving for each student."
  },
  {
    id: 4,
    question: "Are there any crash courses available?",
    answer: "Yes, we offer various crash courses for class 9-12. We also conduct special revision/Maha marathon classes before board exam."
  },
  {
    id: 5,
    question: "How do I enroll my child?",
    answer: "You can visit our institute at Sector 44, Noida, call us at +91 70049 29531 or +91 91621 84962, or fill out the online inquiry form on our website."
  }
];
